/**
 * Tooltip text for the brand-signal dot while a prod rebuild is pending the
 * agent-idle deploy gate (FU-2, #1369). Surfaces "deferred N×" and elapsed wait
 * so a queued rebuild can never again be silently mistaken for a deployed one.
 */
export interface DeployPending {
  deferCount: number;
  firstRequestedAt: string | null;
}

export function formatDeployPending(pending: DeployPending | null | undefined): string {
  if (!pending) return 'Rebuild scheduled';
  const detail: string[] = [];
  if (pending.deferCount > 0) detail.push(`deferred ${pending.deferCount}×`);
  if (pending.firstRequestedAt) {
    const ms = Date.now() - Date.parse(pending.firstRequestedAt);
    if (Number.isFinite(ms) && ms > 30_000) {
      const mins = Math.floor(ms / 60_000);
      detail.push(mins >= 1 ? `${mins}m waiting` : `${Math.round(ms / 1000)}s waiting`);
    }
  }
  return detail.length ? `Rebuild pending — ${detail.join(', ')}` : 'Rebuild pending';
}
